"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEInstant = void 0;
const HistoryEInstantsList_1 = require("./HistoryEInstantsList");
class HistoryEInstant {
    constructor(data) {
        this.transactionID = data.transactionID;
        this.transactionDate = data.transactionDate;
        this.playerId = data.playerId;
        this.provider = data.provider;
        this.gameID = data.gameID;
        this.gameName = data.gameName;
        this.group = data.group;
        this.subGroup = data.subGroup;
        this.platform = data.platform;
        this.purchaseAmount = data.purchaseAmount;
        this.tickets = data.tickets;
        this.freeTickets = data.freeTickets;
        this.mode = data.mode;
        this.cancellable = data.cancellable;
        this.requestProvider = data.requestProvider;
        this.gameImageUrl = data.gameImageUrl;
    }
}
exports.HistoryEInstant = HistoryEInstant;
HistoryEInstant.JsonToEInstants = (data) => {
    const einstantsList = new HistoryEInstantsList_1.HistoryEInstantsList();
    data.forEach(einstant => einstantsList.push(HistoryEInstant.JsonToEInstant(einstant)));
    return einstantsList;
};
HistoryEInstant.JsonToEInstant = (data) => new HistoryEInstant(data);
//# sourceMappingURL=HistoryEInstant.js.map